import { create } from 'zustand';

export const useMeetingStore = create((set) => ({
  title: '',
  setTitle: (val) => {
    set({
      title: val
    })
  }
}))